import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HomeView.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/LoginHome.vue')
  },
  // 论坛广场
  {
    path: '/forumCenter',
    name: 'ForumCenter',
    component: () => import('@/views/ForumCenter.vue')
  },
  // 论坛详情
  {
    path: '/postCenter',
    name: 'PostCenter',
    component: () => import('@/views/PostCenter.vue')
  },
  // 帖子发布
  {
    path: '/publishPost',
    name: 'PublishPost',
    component: () => import('@/views/PublishPost.vue')
  },
  // 帖子内容详情
  {
    path: '/postCenter/postView',
    name: 'PostView',
    component: () => import('@/views/PostView.vue')
  },
  // 搜索
  {
    path: '/search',
    name: 'Search',
    component: () => import('@/views/SearchIndex.vue')
  },
  // 个人中心
  {
    path: '/userCenter',
    name: 'PersonalCenter',
    component: () => import('@/views/PersonalCenter.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
